// @flow
import { Box, Layer } from 'grommet';
import { CircleLoader } from 'react-spinners';
import * as React from 'react';
import styled from 'styled-components';

const SpinnerBox = styled(Box)`
    position: relative;
    z-index: 1300;
    flex-shrink: 0;
`;

const BaseCover = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1200;
  pointer-events: none;
  ${(props) => props.style}
`;

const BlockingCover = styled(Layer)`
 background-color: transparent;
`;

const TYPES = {
    climbingBox: CircleLoader,
    barLoader: CircleLoader,
    clipLoader: CircleLoader,
};

type Props = {
    loading: boolean,
    blocking: boolean,
    type: string,
    coverStyle: Object,
}

const Spinner = (props: Props) => {
    const {
        loading, blocking, type, coverStyle,
    } = props;
    const Cover = blocking ? BlockingCover : BaseCover;
    const Spin = TYPES[type];

    return loading ? (
        <Cover style={coverStyle}>
            <SpinnerBox>
                <Spin
                    sizeUnit="px"
                    size={35}
                    color="#0074d9"
                    {...props}
                />
            </SpinnerBox>
        </Cover>
    ) : null;
};

Spinner.defaultProps = {
    blocking: true,
    type: 'climbingBox',
    coverStyle: {},
};


export default Spinner;
